.container {
  padding: var(--space-6);
  max-width: 1440px;
  margin-inline: auto;
}
